import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const meditor = new Restful(project, 'meditor')

meditor.resubmission = (id, data) => {
  const url = project + 'editor/manuscript/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

export default meditor
